const PinnedSections = (gsap, ScrollTrigger , $) => {

	ScrollTrigger.matchMedia({
		// scroll trigger will only initialized on bigger screens
		"(min-width: 1224px) and (max-width: 1440px)": () => {
			let pinParents = gsap.utils.toArray(".pin-parent");

			pinParents.forEach(parent => {
				let pinnedSection =  $(parent).find(".pin-section")
		
				ScrollTrigger.create({
					trigger: parent,
					pin: pinnedSection,
					start: "top 150px",
					end: "bottom bottom",
				});
			});
		},
		"(min-width: 1441px)": () => {
			let pinParents = gsap.utils.toArray(".pin-parent");

			pinParents.forEach(parent => {
				let pinnedSection =  $(parent).find(".pin-section")
		
				ScrollTrigger.create({
					trigger: parent,
					pin: pinnedSection,
					start: "top 150px",
					end: "bottom center",
				});
			});
		},
	});
};

export default PinnedSections;
